import angular from 'angular';

(function() {
  'use strict';
  angular.module('app.kissorder').factory('OrdersFilterSvc', OrdersFilterSvc);

  OrdersFilterSvc.$inject = ['OrderFilter', 'ORDERS', 'DOCUMENT_FILTER_CONST'];

  function OrdersFilterSvc(OrderFilter, ORDERS, DOCUMENT_FILTER_CONST) {
    var exports = {
      createFilter: createFilter
    };

    return exports;

    /**
     * Créé le filtre de recherche de commandes depuis l'écran de recherche des commandes.
     */
    function createFilter(criterias, gridParams) {
      var orderFilter = new OrderFilter();
      orderFilter.setPageSize(gridParams.paginationPageSize);
      orderFilter.setPage(gridParams.page);
      if (gridParams.sorts) {
        orderFilter.setSorts(gridParams.sorts);
      }
      if (criterias.seller) {
        orderFilter.setSender(criterias.seller);
      }
      if (criterias.buyer) {
        orderFilter.setBuyer(criterias.buyer.id, criterias.buyer.perimeters);
      }
      orderFilter.setPrincipalId(criterias.principalId);
      if (criterias.orderNumber) {
        orderFilter.setDocumentNumber([criterias.orderNumber]);
      }
      orderFilter.setCreationDateFrom(criterias.creationDateFrom);
      orderFilter.setCreationDateTo(criterias.creationDateTo);
      orderFilter.setUpdateDateFrom(criterias.updateDateFrom);
      orderFilter.setUpdateDateTo(criterias.updateDateTo);
      if (criterias.orderType) {
        orderFilter.setDocumentTypes([criterias.orderType]);
      } else {
        orderFilter.setDocumentTypes(ORDERS.type.defaultTypes);
      }
      if (criterias.orderStatus) {
        orderFilter.setStatus([criterias.orderStatus]);
        if (criterias.orderStatus === ORDERS.status.processed.id.toUpperCase()) {
          orderFilter.setDocumentTypes([ORDERS.type.partialOrder]);
        }
      } else {
        orderFilter.setStatus(ORDERS.status.defaultStatus);
      }
      orderFilter.setDocumentOptions([DOCUMENT_FILTER_CONST.option.sellerInfo, DOCUMENT_FILTER_CONST.option.buyerInfo]);
      return orderFilter;
    }
  }
})();
